module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-8.9327851f.svg";